export const userBreakdownReportI18NDe = {
    user: "Benutzer",
    date: "Datum",
    time: "Zeit",
    tasks: "Aufgaben",
    total: () => {
        return "gesamt";
    },
};
